<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div class="form-item tr">
          <span >Policyholder HKID</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.id_type_pic" />
        </div>
        <div class="form-item tr">
          <span>Domestic Helper HKID/ Passport </span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="formData.domestic_id_type_pic" />
        </div>
        <div
          v-if="formData.other_file && formData.other_file.length > 0"
          class="form-item">
          <div class="tr">Additional Documents</div>
          <div class="tr form-item">
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'HousemaidDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
